<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent max-width="600px">
      <template v-slot:activator="{ on }"> 
         
        <v-btn class="px-0 mx-0 bx-0" flat color="black" v-on="on">
          <span>Registrati</span>
          <v-icon class="hidden-md-only" right>account_box</v-icon>
        </v-btn>
      </template>
      <v-card>
        <v-card-title>
          <span class="headline">Registrati</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              
              <v-flex xs12>
                <v-text-field v-model="email" label="Email*" required @keyup.enter="signupSubmitted()"></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field v-model="password" label="Password*" type="password" required @keyup.enter="signupSubmitted()"></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field v-model="confirmPassword" label="Confirm Password*" type="password" required @keyup.enter="signupSubmitted()" :rules="[comparePassword]"></v-text-field>
              </v-flex>
              <span :class="errorClass">{{message}}</span>
            </v-layout>
          </v-container>
          <small>*indicates required field</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="dialog = false">Close</v-btn>
          <v-btn color="blue darken-1" flat @click.prevent="signupSubmitted()">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import fb from "@/fb"
export default {
  data () { 
    return {
      dialog: false,
      email: null,
      password: null,
      confirmPassword: null,
      message: "",
      errorClass: ""
    }
  },
  computed: {
    comparePassword() {
      if (this.password === this.confirmPassword) {
        return true
      } else {
        return "La password non coincide"
      }
    }
  },
  methods: {
    signupSubmitted() {
      if (this.password === this.confirmPassword) {
        fb.auth.createUserWithEmailAndPassword(this.email, this.password).then(() => {
          this.dialog = false
          this.email = null
          this.password = null
          this.confirmPassword = null
          this.errorClass = ""
          fb.auth.onAuthStateChanged(user => {
            user.sendEmailVerification()
          })         
        }).catch(err => {
          this.message = err.message
          //console.log(err.message)
          this.errorClass = "red--text"
        })
      } else {
        this.message = "La password confermata non é corretta!"
        //this.errorClass = "red--text"
      }
    }
  }
}
</script>

<style>

</style>
